<!--  -->
<template>
  <div>
    <div v-if="type === 0">
      <el-tag v-for="itemr,index in funcscopeCategory" :key="index" class="tag_box">{{ itemr }}</el-tag>
    </div>
    <div v-else>
      <!-- <el-tag v-for="itemr,index in arr" :key="index" class="tag_box">666</el-tag> -->
      <el-tag
        v-for="itemr,index in arr"
        :key="index"
        class="tag_box"
        closable
        @close="closetag(itemr,index)"
        @click="lookinfo(itemr)"
      >
        {{ itemr.strategyName }}({{ itemr.strategyNo }})
      </el-tag>
    </div>
  </div>
</template>

<script>
import { unbindaccount } from '@/api/sourceMaterial.js'
export default {
  components: {},
  data() {
    return {
      arr: [],
      type: null,
      appId: null,
      funcscopeCategory: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    lookinfo(item) {
      console.log('item', item)
      this.$router.push({ path: '/customerServicelist/index', query: { ids: item.strategyNo }})
      this.$emit('goruter')
    },
    sendr(arr, id) {
      this.funcscopeCategory = arr

      this.arr = arr.strategys
      this.type = id
      this.appId = arr.appId
      console.log(this.funcscopeCategory, this.arr, this.type, this.appId)
    },
    closetag(item, index) {
      console.log(item)
      this.$confirm('确定解绑策略吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        unbindaccount({
          app_ids: [this.appId],
          strategy_no: item.strategyNo
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '解绑成功!'
          })
          this.arr.splice(index, 1)
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tag_box{
  margin: 0 10px 10px 0px;
}
</style>
